import React, { useState, useEffect, useRef, useMemo } from 'react'
import { Modal, Checkbox, Input, Grid, Segment, Button } from 'semantic-ui-react';
import PropTypes from "prop-types";
import { useTextResources, useMessageResources } from '../../language';
import PaymentTabs from '../Payment/paymentTabs'
import {
    InsertTransactions,
    RenderTemplateToPdf,
    SendEmail,
    GetCurrencyRates
} from '../../api/services/finance'
import { GetReservationTotals } from '../../api/services/pms';
import { onError, onSuccess, onWarning } from '../../components/shared/messages'
import { hasDigitalCertificate } from '../../components/shared/utils'
import { useLoader } from '../../hooks/useLoader';
import moment from 'moment'
import saveAs from 'file-saver'
import { PermissionsActions, UserHasPermission } from '../shared/permissionsActions';


const AddPaymentTransactionPopup = ({ controller, hotel, initFolio, initCurrencyId, initGuestDetails, onSave }) => {
    const text = useTextResources();
    const message = useMessageResources();
    const loader = useLoader();
    const [open, setOpen] = useState(false);
    const [totals, setTotals] = useState()
    const [state, setState] = useState({
        paymentCurrency: initCurrencyId,
        selectedPaymentCurrency: initCurrencyId,
        displayName: "",
        amount: 0,
        hotelCurrency: hotel?.MainCurrencyId || 1,
        HardcodedTypeIDs: [6],
    })
    const [folio, setFolio] = useState(initFolio);
    const [guestDetails, setGuestDetails] = useState(initGuestDetails);
    const [isPrintReceipt, setIsPrintReceipt] = useState(false);
    const [email, setEmail] = useState(initGuestDetails?.email);
    const [isSendEmail, setIsSendEmail] = useState(hotel?.HotelParameter.IsDefaultSendReceiptByMail && initGuestDetails?.email);
    const [isRefund, setIsRefund] = useState(false);
    const [activeTab, setActiveTab] = useState(0)
    const [currencyRates, setCurrencyRates] = useState([])
    const dialogRef = useRef();
    const [displaySave, setDisplaySave] = useState(true);
    const hasRefundAuthorization =  window?.optima?.user?.ActionIDs?.includes(151) || false

    useEffect(() => {
        if (controller) {
            window[controller] = (action, params) => {
                switch (action) {
                    case "open":
                        if (params) {
                            setFolio(params.folio);
                            setGuestDetails(params.guestDetails || initGuestDetails);
                            setState(prev => {
                                return {
                                     ...prev,
                                     paymentCurrency: params.currencyId,
                                     selectedPaymentCurrency: params.currencyId,
                                     isAgentOrCompany: params.isAgentOrCompany
                                    }
                            });
                            getTotals(params.currencyId, params.folio.ReservationId);

                            const email = params.guestDetails?.Email || initGuestDetails?.email;
                            setEmail(email);
                            const isDefaultSendReceiptByMail = hotel.HotelParameter.IsDefaultSendReceiptByMail;
                            setIsSendEmail(isDefaultSendReceiptByMail && email);

                        }
                        setOpen(true)
                        break;
                    default:
                        break;
                }
            }
        }
        getTotals()
    }, [])


    useEffect(() => {
        if (!state.selectedPaymentCurrency) return;

        const camount = calculateCurrencyValue(state.amount, state.paymentCurrency, state.selectedPaymentCurrency)
        if (camount && state.amount !== camount) {
            setState(prev => {
                return {
                    ...prev,
                    amount: camount
                }
            })
            setIsRefund(state.amount < 0);
        }
    }, [state.selectedPaymentCurrency])

    useEffect(() => {
        setIsRefund(state.amount < 0);
    }, [state.amount])

    useEffect(() => {
        if (totals) {
            setState(prev => {
                return {
                    ...prev,
                    amount: totals.TotalAmountDebitAfterTax + totals.TotalAmountCreditAfterTax
                }
            });
        }
    }, [totals])

    useEffect(() => {
        if (hotel) {

            const isDefaultSendReceiptByMail = hotel.HotelParameter.IsDefaultSendReceiptByMail;
            setIsSendEmail(isDefaultSendReceiptByMail && email);

            (async () => {
                try {
                    const currencyRates = await GetCurrencyRates({
                        HotelID: hotel.Id,
                        Date: moment(hotel.HotelParameter.CurrentBusinessDate).startOf("day").toISOString(),
                    })
                    setCurrencyRates(currencyRates)
                } catch (error) {
                    onError(error)
                }
            })()

        }
    }, [hotel])

    const getTotals = (currencyId, reservationId) => {
        const targetCurrencyID = currencyId ? currencyId : state.paymentCurrency;
        const folioReservationId = reservationId ? reservationId : folio && folio.ReservationId;

        if (folioReservationId && targetCurrencyID) {
            (async () => {
                try {
                    const totals = await GetReservationTotals({
                        ReservationIDs: [folioReservationId],
                        HotelId: hotel.Id,
                        TargetCurrencyID: targetCurrencyID
                    })
                    setTotals(totals[0])
                } catch (error) {
                    onError(error)
                }
            })()
        }
    }

    const calculateCurrencyValue = (value, currencyId, targetCurrencyId) => {
        const rate = currencyRates.find(x => x.SourceCurrencyId === currencyId && x.TargetCurrencyId === targetCurrencyId)
        if (rate) {
            return value * rate.PaymentRate
        } else {
            return value
        }
    }

    const printOrEmail = async (transactionIds) => {
        const resEntity = folio && folio.FolioEntities.find(x => x.EntityTypeId === 1)
        const languageId = folio?.Owner?.LanguageID || guestDetails?.languageId;
        const parameters = [
            { key: "CurrencyId", value: state.hotelCurrency },
            { key: "FolioId", value: folio && folio.Id || null },
            { key: "FolioTransactionId", value: transactionIds },
            { key: "ReCalcTaxExemptions", value: true },
            { key: "CalculateAdditionalTaxes", value: true },
            { key: "IsGroupByProduct", value: hotel.HotelParameter.IsDisplayFolioTransactionsGroupedByProduct },
            { key: "IsGroupByTransactionCodeAndType", value: false },
            { key: "IssuedByUserName", value: window.user ? `${window.user.FirstName} ${window.user.LastName}` : "Developer" },
            { key: "ReservationId", value: resEntity && resEntity.EntityId || null },
            { key: "PaymentCurrencyId", value: state.selectedPaymentCurrency },
            { key: "InvoiceTitle", value: text("Statement") },
            { key: "GuestTitle", value: guestDetails.salutation || "" },
            { key: "GuestFirstName", value: guestDetails.fname || folio.Owner.Name || "" },
            { key: "GuestLastName", value: guestDetails.lname || "" },
            { key: "CustomerVATNumber", value: guestDetails.vat || "" },
            { key: "GuestStreetAndNumber", value: guestDetails.street || "" },
            { key: "GuestCity", value: guestDetails.city || "" },
            { key: "GuestZip", value: guestDetails.zip || "" },
            { key: "GuestCountryName", value: guestDetails.country || "" },
            { key: "GuestState", value: guestDetails.state || "" },
            { key: "GuestPhone", value: guestDetails.phone || "" },
            { key: "GuestEmail", value: isSendEmail ? email : guestDetails.email || "" },
            { key: "GuestIdentityCardNumber", value: guestDetails.idnumber || "" },
            { key: "LanguageId", value: languageId }
        ]
        try {
            const receipt = await RenderTemplateToPdf({
                HotelID: hotel && hotel.Id,
                TemplateTypeID: 17,
                FileName: "statement.pdf",
                Paramters: parameters,
                EntityID: folio.Owner?.EntityId,
                EntityTypeID: folio.Owner?.EntityTypeId,
                LanguageID: languageId,
            })
            if (isPrintReceipt) {
                saveAs(receipt.DmzUrlPathAccessibleByBrowser)
            }
            if (isSendEmail) {
                await SendEmail({
                    PdfDto: { ...receipt },
                    IsAttachBodyAsPdf: true,
                    To: email ? email : guestDetails.email,
                    Subject: "Receipt"
                })
            }
        } catch (error) {
            error.status === 400 ? onWarning(error) : onError(error)
        }
    }

    const save = async () => {
        if (!onSaveValidation()) return;

        if (!(await hasDigitalCertificate())) {
            return onWarning(message("MissingPermissionsForDigitalInvoice"));
        }

        loader(true);

        try {
            let newtransactions = []

            if (activeTab === 1 && dialogRef.current) {
                const paymentResponse = await dialogRef.current.saveAction();
                if (!paymentResponse || !paymentResponse.FolioTransactionID) {
                    return onError(text('ErrorOccured'));
                }
                paymentResponse.PathOriginal && saveAs(paymentResponse.PathOriginal);
                newtransactions.push({
                    Id: paymentResponse.FolioTransactionID
                })
            } else {
                const _amount = state.amount * -1;
                let checksDetails = []
                if (state.ChecksDetails) {
                    checksDetails.push({
                        ID: state.ChecksDetails.Id,
                        BankID: state.ChecksDetails.BankID,
                        BranchCode: state.ChecksDetails.BranchCode,
                        CheckNumber: state.ChecksDetails.CheckNumber,
                        CheckDate: state.ChecksDetails.CheckDate,
                        AccountNumber: state.ChecksDetails.AccountNumber,
                        FolioTransactionID: state.ChecksDetails.FolioTransactionID
                    })
                }
                newtransactions.push({
                    Id: 0,
                    Amount: _amount,
                    AmountBeforeTax: _amount,
                    AmountAfterTax: _amount,
                    Comments: state.comments,
                    CurrencyId: state.selectedPaymentCurrency,
                    FolioId: folio && folio.Id,
                    HotelID: hotel && hotel.Id,
                    IsVoid: false,
                    TransactionDisplayName: state.displayName,
                    TransactionCodeId: state.transactionCodeID,
                    Voucher: state.voucher,
                    Quantity: 1,
                    SendEmailTo: state.sendEmail && email,
                    ChecksDetails: checksDetails
                })

                newtransactions = await InsertTransactions(newtransactions)
            }

            if (isPrintReceipt || isSendEmail) {
                await printOrEmail(newtransactions[0].Id);
            }

            if (onSave) onSave();
            onSuccess();
            close();
        } catch (error) {
            error.status === 400 ? onWarning(error) : onError(error)
        }
        finally {
            loader(false)
        }
    }

    const onSaveValidation = () => {
        if (state.amount < 0 && !UserHasPermission(PermissionsActions.PaymentPerformRefund)) {
            onWarning(text('NoRefundPermissions'));
            return false;
        }
        if (isSendEmail) {
            if (!email) {
                onWarning(text('mobile_email_incorrect'));
                return false;
            }
        }
        if (activeTab === 0) {
            if (!state.transactionCodeID) {
                onWarning(text('InsertTransaction'));
                return false;
            }
            // Validate voucher is required when isExternalVoucherRequired is true
            if (state.isExternalVoucherRequired && (!state.voucher || state.voucher.trim() === '')) {
                onWarning(text('VoucherRequired'));
                return false;
            }
        }
        return true;
    }

    const close = () => {
        cleanData();
        setOpen(false);
    }

    const cleanData = () => {
        setFolio(null);
        setState({ 
            ...state, 
            displayName: "",
            voucher: "",
            comments: ""
        });
    }

    const Is3dsOpenChange = (is3dsOpen) => {
        setDisplaySave(!is3dsOpen);
    };

    const validateAmountAndUpdateState = (data) => {
        if(data?.amount < 0 && !hasRefundAuthorization){
            onWarning(text('NoRefundPermissions'));
        }
        setState(data)
    }

    const disableSave = useMemo(() => {
        if (state.amount === 0 ||
            (isRefund && (activeTab == 1 || !hasRefundAuthorization))) return true;
        return false;
    },[state.amount, activeTab, isRefund, hasRefundAuthorization])

    return (
        <Modal size="small" open={open} style={{ zIndex: 1000000 }} >
            <Modal.Header>{text("PaymentMethods")}</Modal.Header>
            <Modal.Content>
                <Segment>
                    <Grid columns='equal'>
                        <Grid.Column width={4}>
                            <Checkbox
                                label={<label>{text('PrintReceipt')}</label>}
                                checked={isPrintReceipt}
                                onChange={(e, { checked }) => setIsPrintReceipt(checked)} />
                        </Grid.Column>
                        <Grid.Column width={9}>
                            <Checkbox
                                label={<label>{text('SendEmail')}</label>}
                                checked={isSendEmail}
                                onChange={(e, { checked }) => setIsSendEmail(checked)} />
                            <Input style={{ marginLeft: "5px" }} size='small' icon='mail' disabled={!isSendEmail} value={email} onChange={(e, { value }) => setEmail(value)} />
                        </Grid.Column>
                        <Grid.Column width={3} style={{ paddingLeft: 0 }}>
                            {hasRefundAuthorization && <Checkbox
                                toggle
                                label={<label>{text('Refund')}</label>}
                                checked={isRefund}
                                onChange={(e, { checked }) => setIsRefund(checked)}
                                onClick={() => setState({ ...state, amount: (state.amount * -1) })} />}
                        </Grid.Column>
                    </Grid>
                </Segment>
                <PaymentTabs
                    state={state}
                     setState={(data) => validateAmountAndUpdateState(data)}
                    dialogRef={dialogRef}
                    hotel={hotel}
                    setActiveTab={setActiveTab}
                    folio={folio}
                    onIs3dsOpenChange={Is3dsOpenChange} 
                    isPaymentDialogReadOnly={isRefund}/>
            </Modal.Content>
            { displaySave && <Modal.Actions>
                <Button size={"small"} negative onClick={close}>{text("Close")}</Button>
                <Button size={"small"} positive onClick={save}  disabled={disableSave}>{text("Save")}</Button>
            </Modal.Actions>}
        </Modal>
    )
}

AddPaymentTransactionPopup.propTypes = {
    hotel: PropTypes.object,
    initFolio: PropTypes.object,
    transactionIds: PropTypes.array,
    controller: PropTypes.any,
    open: PropTypes.bool,
    initCurrencyId: PropTypes.number,
    initGuestDetails: PropTypes.object,
    onSave: PropTypes.func
}

export default AddPaymentTransactionPopup
